// Define permissions
export const PERMISSIONS = {
    // Content Access
    VIEW_BASIC_CONTENT: 'view:basic_content',
    VIEW_PRO_CONTENT: 'view:pro_content',
    VIEW_ADMIN_DASHBOARD: 'view:admin_dashboard',
    
    // Features
    USE_TWITTER_FEATURE: 'use:twitter_feature',
    USE_PRO_CHAT: 'use:pro_chat',
    USE_PRO_POEM: 'use:pro_poem',
    USE_CUSTOM_BUILD: 'use:custom_build',
    MANAGE_GALLERIES: 'manage:galleries',
    TRACK_PURCHASES: 'track:purchases',
    VIEW_PURCHASED_CONTENT: 'view:purchased_content',
    
    // Admin Operations
    MANAGE_USERS: 'manage:users',
    MANAGE_CONTENT: 'manage:content',
    VIEW_ANALYTICS: 'view:analytics'
};

// Define roles and their permissions
export const ROLES = {
    USER: 'user',
    PRO_USER: 'pro_user',
    ADMIN: 'admin'
};

// Define permission sets for each role
export const ROLE_PERMISSIONS = {
    [ROLES.USER]: [
        PERMISSIONS.VIEW_BASIC_CONTENT
    ],
    [ROLES.PRO_USER]: [
        PERMISSIONS.VIEW_BASIC_CONTENT,
        PERMISSIONS.VIEW_PRO_CONTENT,
        PERMISSIONS.USE_TWITTER_FEATURE, // can likely be removed
        PERMISSIONS.USE_PRO_CHAT,
        PERMISSIONS.USE_PRO_POEM, // can likely be removed
        PERMISSIONS.USE_CUSTOM_BUILD,
        PERMISSIONS.TRACK_PURCHASES,
        PERMISSIONS.VIEW_PURCHASED_CONTENT
    ],
    [ROLES.ADMIN]: [
        PERMISSIONS.VIEW_BASIC_CONTENT, 
        PERMISSIONS.VIEW_PRO_CONTENT,
        PERMISSIONS.VIEW_ADMIN_DASHBOARD, // admin specific
        PERMISSIONS.USE_TWITTER_FEATURE, // can likely be removed
        PERMISSIONS.USE_PRO_CHAT,
        PERMISSIONS.USE_PRO_POEM, // can likely be removed
        PERMISSIONS.USE_CUSTOM_BUILD,
        PERMISSIONS.MANAGE_GALLERIES, // admin specific
        PERMISSIONS.TRACK_PURCHASES,
        PERMISSIONS.VIEW_PURCHASED_CONTENT,
        PERMISSIONS.MANAGE_USERS, // admin specific
        PERMISSIONS.MANAGE_CONTENT, // admin specific
        PERMISSIONS.VIEW_ANALYTICS // admin specific
    ]
};

// Helper function to get roles from user data
export const getUserRoles = (userData) => {
    const roles = [ROLES.USER]; // Default role for all users
    
    // Debug logging removed for production
    
    // Check for explicit role assignment first
    if (userData?.role) {
        // Map the stored role to our role constants
        switch (userData.role) {
            case 'pro_user':
                roles.push(ROLES.PRO_USER);
                break;
            case 'admin':
                roles.push(ROLES.ADMIN);
                break;
            case 'user':
            default:
                // Already have USER role, no additional roles needed
                break;
        }
    } else {
        // Fallback to legacy boolean flags for backward compatibility
        if (userData?.isPro) {
            roles.push(ROLES.PRO_USER);
        }
        
        if (userData?.isAdmin) {
            roles.push(ROLES.ADMIN);
        }
    }

    // Debug logging removed for production
    
    return roles;
};

// Helper function to check if user has permission
export const hasPermission = (userRoles, permission) => {
    return userRoles.some(role => 
        ROLE_PERMISSIONS[role]?.includes(permission)
    );
};

// Helper function to check if user has any of the given permissions
export const hasAnyPermission = (userRoles, permissions) => {
    return permissions.some(permission => hasPermission(userRoles, permission));
};

// Helper function to check if user has all of the given permissions
export const hasAllPermissions = (userRoles, permissions) => {
    return permissions.every(permission => hasPermission(userRoles, permission));
}; 